import { render, staticRenderFns } from "./OverdueItemReport.vue?vue&type=template&id=7d8f7ff2"
import script from "./OverdueItemReport.vue?vue&type=script&lang=js"
export * from "./OverdueItemReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports